import { AddressInput, CalendarEventDetailsFragment, CalendarEventLocationTypeEnum, UpdateCalendarEventInput } from 'generated/graphql';

/**
 * Combined form data for add (CalendarEventInput) & edit (UpdateCalendarEventInput)
 */
export interface EventFormState {
  id?: string;
  campaignId?: string;
  name: string;
  entityTypeId: string;
  startDate: string;
  endDate?: string;
  timeZone: string;
  locationType: CalendarEventLocationTypeEnum;
  address?: AddressInput;
  locationNote?: string;
  description: string;
  assignedUsers: string[];
  actionConfirmScheduledDays?: number;
  actionDoubleConfirmScheduledDays?: number;
  actionLogAttendanceScheduledDays?: number;
  actionNetworkEventId?: string;
}

/**
 * Transforms CalendarEventDetailsFragment into EventFormState for editing
 */
export function createEventFormState(eventInfo: CalendarEventDetailsFragment): EventFormState {
  // Remove extra props from AddressDetailsFragment
  let address: AddressInput;
  if (eventInfo.address) {
    address = {
      country: eventInfo.address.country,
      city: eventInfo.address.city,
      state: eventInfo.address.state,
      streetAddress: eventInfo.address.streetAddress,
      zip: eventInfo.address.zip,
    };
  }
  return {
    id: eventInfo.id,
    name: eventInfo.name,
    entityTypeId: eventInfo.entityType.id,
    startDate: eventInfo.startDate,
    endDate: eventInfo.endDate,
    timeZone: eventInfo.timeZone,
    locationType: eventInfo.locationType,
    locationNote: eventInfo.locationNote,
    address,
    description: eventInfo.description,
    assignedUsers: eventInfo.assignedUsers.nodes.map(user => user.id),
    actionNetworkEventId: eventInfo.actionNetworkEventId,
  };
}

/**
 * Transforms EventFormState into UpdateCalendarEventInput for editing
 */
export function createUpdateCalendarEventInput(calendarEvent: EventFormState): UpdateCalendarEventInput {
  const calendarEventInput: UpdateCalendarEventInput = {
    id: calendarEvent.id,
    name: calendarEvent.name,
    startDate: calendarEvent.startDate,
    locationType: calendarEvent.locationType,
    description: calendarEvent.description,
    timeZone: calendarEvent.timeZone,
  };
  if (calendarEvent.endDate) {
    calendarEventInput.endDate = calendarEvent.endDate;
  } else {
    calendarEventInput.endDate = null;
  }
  if (calendarEvent.locationType === CalendarEventLocationTypeEnum.InPerson) {
    calendarEventInput.address = calendarEvent.address;
  }
  if (calendarEvent.locationType === CalendarEventLocationTypeEnum.Virtual) {
    calendarEventInput.locationNote = calendarEvent.locationNote;
  }
  return calendarEventInput;
}
